module.exports = __webpack_public_path__ + "d4df4b91b11358100942267eb6e2c3dc.png";